/**
 * User-configurable security features.
 *
 * This is deliberately separate from Prisma's SecurityFeatureType, which is the ranking vocabulary
 * and includes derived rows such as RESIDUE, PRINCIPAL and OPTION. Compatibility rules for this
 * vocabulary live in securityFeatureRules.ts; ranking rules live in
 * backend/module/security/ranking/rankableSecurityFeature.ts.
 */
export enum SecurityFeature {
	AUTHORISED_CAPITAL = 'AUTHORISED_CAPITAL',
	INCOME_RIGHTS_INTEREST = 'INCOME_RIGHTS_INTEREST',
	INCOME_RIGHTS_TRACKING = 'INCOME_RIGHTS_TRACKING',
	REDEMPTION_RIGHTS = 'REDEMPTION_RIGHTS',
	CATCH_UP_RIGHTS = 'CATCH_UP_RIGHTS',
	EXCHANGE_RIGHTS = 'EXCHANGE_RIGHTS',
	LIQUIDATION_PREFERENCE = 'LIQUIDATION_PREFERENCE',
	PARTICIPATION_THRESHOLD = 'PARTICIPATION_THRESHOLD',
	RATCHETING = 'RATCHETING',
}
